import { CallableInput } from "Components/Shared";
import ASRSelect from "Components/Shared/ASRSelect";
import DNSTypeSelect from "Components/Shared/DNSTypeSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import TTSSelect from "Components/Shared/TTSSelect";
import { Field, Formik } from "formik";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Card, Container, Form } from "semantic-ui-react";
import * as yup from "yup";

const VoiceRegionSchema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
  ttsLanguage: yup.string().required(),
  asrLanguage: yup.string().required(),
  dialTimeout: yup.number().required(),
  dialTimeLimit: yup.number().required(),
  teamsDomain: yup.string().required(),
  ringbackURL: yup.string().required(),
  monitoringURL: yup.string().required(),
  monitoringUsername: yup.string().required(),
  monitoringPassword: yup.string().required(),
});

const RegionCreateForm = () => {
  const { create, uncreate, save } = useVoiceRegion();

  return (
    <Container fluid style={{ padding: "20px" }}>
      <h2>Create Voice Region</h2>
      <Card fluid>
        <Card.Content>
          <Formik
            validateOnChange={false}
            initialValues={create}
            validationSchema={VoiceRegionSchema}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              save(values);
            }}
          >
            {({ handleSubmit, errors, validateField, values }) => (
              <Form onSubmit={handleSubmit}>
                <Field name='name' label='Name' component={CallableInput} />

                <Field
                  name='description'
                  label='Description'
                  component={CallableInput}
                />

                <TTSSelect name='ttsLanguage' label='TTS Language' />

                <ASRSelect name='asrLanguage' label='ASR Language' />

                <Field
                  name='dialTimeLimit'
                  label='Dial Time Limit'
                  component={CallableInput}
                />

                <Field
                  name='dialTimeout'
                  label='Dial Timeout'
                  type='number'
                  component={CallableInput}
                />

                <Field
                  name='ringbackURL'
                  label='Ringback URL'
                  component={CallableInput}
                />

                <Field
                  name='teamsDomain'
                  label='Teams Domain'
                  component={CallableInput}
                />

                <Field
                  name='monitoringURL'
                  label='Monitoring URL'
                  component={CallableInput}
                />

                <Field
                  name='monitoringUsername'
                  label='Monitoring Username'
                  component={CallableInput}
                />

                <Field
                  name='monitoringPassword'
                  label='Monitoring Password'
                  component={CallableInput}
                />

                <Field
                  name='applicationURL'
                  label='Application URL'
                  component={CallableInput}
                />

                <DNSTypeSelect name='dnsType' label='DNS Selection Type' />

                <Field
                  name='dnsISOCode'
                  label='DNS Codes'
                  component={CallableInput}
                />

                <FormSubmit
                  name='Update'
                  errors={errors}
                  onCancel={() => uncreate()}
                />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </Container>
  );
};

export default RegionCreateForm;
